import React from "react";
import MenuButton from "./menuButton";
import { Link } from "gatsby";
import { Socials, StrokeText } from "../components";
import { useMenu } from "../state";

/* Header
============================================================================= */

const Header = () => {
	// Config
	const { setPopupOpen } = useMenu();

	// Render
	return (
		<header
			className="fixed top-0 left-0 z-50 flex items-center justify-end w-full shadow-xl h-14 md:h-20 md:justify-between overflow-hidden"
			style={{ backgroundColor: "#f99e3b" }}
		>
			<div className="hidden pl-6 md:block">
				<Socials />
			</div>
			<div className="flex flex-row items-center justify-between w-full pl-6 md:justify-end md:w-auto md:pl-0">
				<div className="flex flex-row items-center justify-start w-full md:space-x-0 space-x-6">
					<Link
						to="/event-info"
						className="pt-2 pr-0 md:pt-3 md:pr-6"
					>
						<StrokeText
							text="Event Info"
							size="md:text-4xl text-2xl"
							alignment="text-right"
						/>
					</Link>
					<a
						href="https://goodthings2022.cc/gtf_website_nav-bar_gen"
						target="_blank"
						rel="noopener noreferrer"
						className="pt-2 pr-0 cursor-pointer md:pt-3 md:pr-6"
					>
						<StrokeText
							text="BUY TICKETS"
							size="md:text-4xl text-2xl"
							alignment="text-right"
						/>
					</a>
				</div>
				<MenuButton />
			</div>
		</header>
	);
};

/* Export
============================================================================= */

export default Header;
